module.exports = __webpack_public_path__ + "img/falcon-edge-icon-black-logo.d7b51a9.png";